import TitleBlock, { TitleBlockProps, TitleDescription } from '@anm/components/TitleBlock';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

export type PlanVariant = 'green' | 'grey' | 'blue' | 'yellow' | 'pink';
export type PlanTitleBlockProps = TitleBlockProps & {
  variant: PlanVariant;
};
export const priceVariants: { [key in PlanVariant]: ReturnType<typeof css> } = {
  grey: css`
    color: #919eaa;
  `,
  blue: css`
    color: var(--blue_100);
  `,
  green: css`
    color: #4eda9d;
  `,
  yellow: css`
    color: var(--error);
  `,
  pink: css`
    color: #9c4be3;
  `
};

const planTitleMobile = media.phone`
    h1, h2, h3, h4, h5, h6 {
        font-size: 28px;
        line-height: 34px;
        margin-bottom: 7px;
    }
`;

const planDescriptionMobile = media.phone` 
   ${TitleDescription} {
    font-size: 14px;
    line-height: 22px;
  }
`;

export default styled(TitleBlock)<PlanTitleBlockProps>`
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
    margin: 0;
    color: inherit;
  }
  ${TitleDescription} {
    font-weight: normal;
    font-size: 16px;
    line-height: 25px;
  }
  ${({ variant }) => priceVariants[variant]}
  ${planTitleMobile};
  ${planDescriptionMobile};
`;
